import React from 'react';
import { IconTypes } from './iconTypes';

export const Icon = ({
  name,
  size = 36,
  color = 'black',
  ...restOfProps
}: IconTypes.IIcon) => {
  if (name?.includes('path')) {
    const [iconName, number] = name.split('-path');
    const numberOftimes = parseInt(number, 10);
    const renderPaths = () => {
      switch (numberOftimes) {
        case 2:
          return (
            <>
              <span className="path1"></span>
              <span className="path2"></span>
            </>
          );
        case 4:
          return (
            <>
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </>
          );
        default:
          return (
            <>
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
              <span className="path5"></span>
            </>
          );
      }
    };
    return (
      <i
        className={iconName}
        style={{
          fontSize: size,
          color: color,
        }}
      >
        {renderPaths()}
      </i>
    );
  }
  return (
    <i
      className={name}
      {...restOfProps}
      style={{
        fontSize: size,
        color: color,
      }}
    />
  );
};
